import { navigationRef } from '../services/navigationService';

import { createLogger } from './logger';
const logger = createLogger('NotificationNavigator');

// Map screens to their parent navigators
const screenToNavigatorMap: Record<string, string> = {
  // Personal screens
  'PersonalInfoInput': 'Personal',
  'PersonalInfoInputScreen': 'Personal',
  'PersonalInfoIntro': 'Personal',
  'PersonalInfoLockUnlock': 'Personal',
  'SpouseInfoIntro': 'Personal',
  'SpouseInfoInput': 'Personal',
  'ChildrenInfoIntro': 'Personal',
  'ChildrenInfoInput': 'Personal',
  'PetIntro': 'Personal',
  'PetInfoInput': 'Personal',
  'EmploymentIntro': 'Personal',
  'EmploymentInfoInput': 'Personal',
  // Medical screens
  'PrimaryPhysicianIntro': 'Medical',
  'PrimaryPhysicianInput': 'Medical',
  'SpecialtyPhysicianIntro': 'Medical',
  'MedicationsIntro': 'Medical',
  'MedicationsLockUnlock': 'Medical',
  'TreatmentsIntro': 'Medical',
  'MedicalHistoryIntro': 'Medical',
  'OrganDonorIntro': 'Medical',
  // Profile screens
  'Settings': 'Profile',
  'EditProfile': 'Profile',
  'ChangePassword': 'Profile',
  'AddSuccessor': 'Profile',
  'SuccessorDetails': 'Profile',
  'AddKeyholder': 'Profile',
  'KeyHolderDetails': 'Profile',
  'SecretCodeRecipients': 'Profile',
  'SecretCode': 'Profile',
  'DeathAccessPolicy': 'Profile',
};

export function navigateToNotificationTarget(
  actionType: string | null | undefined,
  actionData: any,
): void {
  if (actionType !== 'navigate' || !actionData?.screen) {
    return;
  }

  const { screen, navigator, params } = actionData;

  if (!navigationRef.isReady()) {
    logger.error('Navigation ref is not ready');
    return;
  }

  // If a navigator is specified, use nested navigation
  if (navigator) {
    // @ts-ignore - dynamic navigation params
    navigationRef.navigate(navigator, { screen, params });
    return;
  }

  // Normalize screen name (remove "Screen" suffix if present)
  const normalizedScreen = screen.replace(/Screen$/, '');
  const targetNavigator =
    screenToNavigatorMap[screen] || screenToNavigatorMap[normalizedScreen];

  if (targetNavigator) {
    const screenName = normalizedScreen || screen;
    // @ts-ignore - dynamic navigation params
    navigationRef.navigate(targetNavigator, { screen: screenName, params });
  } else {
    // Fallback: try direct navigation (for screens in current navigator)
    // @ts-ignore - dynamic navigation params
    navigationRef.navigate(screen, params);
  }
}
